module.exports = {
  BRIEF_PAGE_PATH: 'brief-auto-match',
  WIX_DOMAIN: 'wix.com',
  EDITORX_DOMAIN: 'editorx.com',
  MORE_DETAILS_SCREEN_SLUG: 'more-details',
  SITE_SELECTOR_SCREEN_SLUG: 'site-selector',
  SEO_SERVICES_SERVICE_SLUG: 'seo-services',
  ARTIFACT_ID_JS: 'partners-marketplace-nextjs',
};
